module.exports = __webpack_public_path__ + "static/media/try_another_device.486139e3.svg";